export class DistributorResponseApi {
    id: number;
    bairro: string;
    categoria: string;
    cidade: string;
    cnpj: string;
    codigo: number;
    codigoCompanhia: number;
    condicaoPagto: string;
    endereco1: string;
    endereco2: string;
    grupo: string;
    isentaIpi: boolean;
    licenca: string;
    nome: string;
    pais: string;
    suframa: string;
    tipo: string;
    tipoDescricao: string;
    trade: string;
    zona: string;
    autorizacaoSanasa?: boolean;

    fromJSON(): DistributorResponse {
        return {
            id: this.id,
            bairro: this.bairro,
            categoria: this.categoria,
            cidade: this.cidade,
            cnpj: this.cnpj,
            codigo: this.codigo,
            codigoCompanhia: this.codigoCompanhia,
            condicaoPagto: this.condicaoPagto,
            endereco1: this.endereco1,
            endereco2: this.endereco2,
            grupo: this.grupo,
            isentaIpi: this.isentaIpi,
            licenca: this.licenca,
            nome: this.nome,
            pais: this.pais,
            suframa: this.suframa,
            tipo: this.tipo,
            tipoDescricao: this.tipoDescricao,
            trade: this.trade,
            zona: this.zona,
            autorizacaoSanasa: !!this.autorizacaoSanasa,
        };
    }
}

export class DistributorResponse {
    id: number;
    bairro: string;
    categoria: string;
    cidade: string;
    cnpj: string;
    codigo: number;
    codigoCompanhia: number;
    condicaoPagto: string;
    endereco1: string;
    endereco2: string;
    grupo: string;
    isentaIpi: boolean;
    licenca: string;
    nome: string;
    pais: string;
    suframa: string;
    tipo: string;
    tipoDescricao: string;
    trade: string;
    zona: string;
    autorizacaoSanasa?: boolean;
}
